<template>
  <div class="page-container-summary">
    <LandingBar active="dashboard" />
    <div class="buy-wrapper">
      <div class="summary-upper">
        <div class="summary-left2">
          <div class="dashboard-left-top">
            <h1 class="table-headline">Current Market</h1>
            <v-btn depressed color="#59c26b" class="transfer-button">
              <a href='matchingAdmin'>Buy/Sell</a></v-btn
            >
          </div>
          <div class="balance-flex2">
            <div class="balance2">
              <div class="summary-header">Request</div>
              <div class="dash-balance">
                {{ this.totalRequest }} <span class="offer-span">KWh</span>
              </div>
              <div class="dash-total">Total volume</div>
              <div class="dash-balance">
                {{ this.minRequestPrice }}<span class="offer-span">&euro;</span> - {{ this.maxRequestPrice }}<span
                  class="offer-span"
                  >&euro;</span
                >
              </div>
              <div class="dash-total">Price</div>
            </div>
            <div class="balance2">
              <div class="summary-header">Offer</div>
              <div class="dash-balance">
                {{ this.totalOffer }} <span class="offer-span">KWh</span>
              </div>
              <div class="dash-total">Total volume</div>
              <div class="dash-balance">
                {{ this.minOfferPrice }}<span class="offer-span">&euro;</span> - {{ this.maxOfferPrice }}<span
                  class="offer-span"
                  >&euro;</span
                >
              </div>
              <div class="dash-total">Price</div>
            </div>
          </div>
          <div class="summary-middle-table2 table-wrapper2">
            <div class="dashboard-right-top2 dash-head">
              <h1 class="table-headline">Current update</h1>
              <v-btn-toggle mandatory class="dash-toggle">
                <v-btn
                  color="#59c26b"
                  outlined
                  class="toggle-button"
                  :value="0"
                  @click="selectNewRequests"
                >
                  New requests
                </v-btn>
                <v-btn
                  color="#59c26b"
                  outlined
                  class="toggle-button"
                  :value="1"
                  @click="selectNewOffers"
                >
                  New offers
                </v-btn>
              </v-btn-toggle>
            </div>
            <table>
              <thead>
                <tr>
                  <th>Location</th>
                  <th>Date from</th>
                  <th>Type of day</th>
                  <th>Volume (MW<span class="lowercase">h</span>)</th>
                  <th>Price (&euro;)</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(fiveLatestRecord, index) in fiveLatestRecords"
                  :key="index"
                >
                  <td>{{ fiveLatestRecord.locationCode }}</td>
                  <td>{{ fiveLatestRecord.dateFrom }}</td>
                  <td>{{ fiveLatestRecord.dayType }}</td>
                  <td style="text-align:center">{{ fiveLatestRecord.volume }}</td>
                  <td style="text-align:center">{{ fiveLatestRecord.price }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="summary-right2">
          <div class="dashboard-right-top dash-head">
            <h1 class="table-headline">Flex Market</h1>
            <v-btn-toggle mandatory class="dash-toggle">
              <v-btn color="#59c26b" outlined class="toggle-button" :value="0" @change="changeFlexMarket()">
                Volume
              </v-btn>
              <v-btn color="#59c26b" outlined class="toggle-button" :value="10" @change="changeFlexMarket()">
                Price
              </v-btn>
            </v-btn-toggle>
          </div>
          <div class="summary-graph" v-if="!showingVolume">
            <DashboardLine />
          </div>
          <div class="summary-graph" v-if="!showingPrice">
            <DashboardLinePrice />
          </div>
        </div>
      </div>
      <div class="summary-middle2"></div>
      <div class="dash-candle">
        <div class="dashboard-right-top dash-head">
          <h1 class="table-headline">Wholesale Market</h1>
          <v-row mandatory class="dash-toggle">
            <v-col
              cols="12"
              sm="6"
              md="4"
            >
              <v-menu
                ref="menu"
                v-model="menu"
                :close-on-content-click="false"
                :return-value.sync="date"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="dateData"
                    label="Choose a date"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="dateData"
                  no-title
                  scrollable
                  @input="(e) => changeDateData(e)"
                >
                  <v-spacer></v-spacer>
                  <v-btn
                    text
                    color="primary"
                    @click="menu = false"
                  >
                    Cancel
                  </v-btn>
                  <v-btn
                    text
                    color="primary"
                    @click="$refs.menu.save(dateData)"
                  >
                    OK
                  </v-btn>
                </v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
          <v-btn-toggle mandatory class="dash-toggle">
            <v-btn color="#59c26b" outlined class="toggle-button" :value="0" @change="changeWholeSaleMarket()">
              Day ahead
            </v-btn>
            <v-btn color="#59c26b" outlined class="toggle-button" :value="10" @change="changeWholeSaleMarket()">
              Intra day
            </v-btn>
            <!-- <v-btn color="#59c26b" outlined class="toggle-button" :value="20" @change="changeWholeSaleMarket()">
              Balancing
            </v-btn> -->
            
          </v-btn-toggle>
          
          <!-- <v-menu
            ref="dateMenu"
            v-model="dateMenu"
            :close-on-content-click="false"
            :return-value.sync="date"
            transition="scale-transition"
            offset-y
            min-width="auto"
            with=100
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="date"
                label="Please choose the date"
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="date"
              @input="dateMenu = true"
              no-title
              scrollable
            ></v-date-picker>
          </v-menu> -->
        </div>
        <div class="summary-graph" v-if="!showingDayAhead">
            <DayAheadChart />
          </div>
          <div class="summary-graph" v-if="!showingIntraDay">
            <IntraDayChart />
          </div>
      </div>
      <!-- <div class="headline-wrapper">
        <div class="headline-top">
          <h1 class="table-headline headline-headline">Headlines</h1>
          <div class="headline-subheader">Today, 9th September 2021</div>
        </div>
        <div class="headline-main">
          <div class="headline-left headline">
            <img src="../img/Headline1.png" alt="headline1" class="headline-img"/>
            <div class="headline-bold">
              Lorem Ipsum is simply dummy text of the printing and typesetting
              industry.
            </div>
            <div class="headline-text">
              Lorem Ipsum has been the industry's standard dummy text ever since
              the 1500s, when an unknown printer took a galley of type and
              scrambled
            </div>
          </div>
          <div class="headline-middle headline">
            <img src="../img/Headline2.png" alt="headline3" class="headline-img" />
            <div class="headline-bold">
              Lorem Ipsum is simply dummy text of the printing and typesetting
              industry.
            </div>
            <div class="headline-text">
              Lorem Ipsum has been the industry's standard dummy text ever since
              the 1500s, when an unknown printer took a galley of type and
              scrambled
            </div>
          </div>
          <div class="headline-right headline">
            <div class="headline-bold">
              Lorem Ipsum is simply dummy text of the printing and typesetting
              industry.
            </div>
            <div class="headline-text">
              Lorem Ipsum has been the industry's standard dummy text ever since
              the 1500s, when an unknown printer took a galley of type and
              scrambled
            </div>
            <img src="../img/Headline3.png" alt="headline3" class="headline-img" />
          </div>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import LandingBar from "../components/Common/LandingBarAdmin.vue";
import DashboardLine from "../components/Charts/DashboardLine";
import DashboardLinePrice from "../components/Charts/DashboardLinePrice";
import IntraDayChart from "../components/Charts/IntraDayChart";
import DayAheadChart from "../components/Charts/DayAheadChart";
import { mdiScaleBalance, mdiCurrencyEur, mdiRepeat } from "@mdi/js";

import RequestDataService from "../services/RequestDataService";
import OfferDataService from "../services/OfferDataService";

export default {
  components: { LandingBar, DashboardLine, DashboardLinePrice, DayAheadChart, IntraDayChart },
  data() {
    return {
      icons: {
        mdiScaleBalance,
        mdiCurrencyEur,
        mdiRepeat,
      },
      bread: [
        {
          text: "Portfolio Management",
          disabled: false,
        },
        {
          text: "Summary",
          disabled: false,
        },
      ],

      requests: [],
      fiveLatestRequests: [],
      totalRequest: 0,
      minRequestPrice: 0,
      maxRequestPrice: 0,
      
      offers: [],
      fiveLatestOffers: [],
      totalOffer: 0,
      minOfferPrice: 0,
      maxOfferPrice: 0,

      fiveLatestRecords: [],

      showingPrice: true,
      showingVolume: false,

      showingDayAhead: false,
      showingIntraDay: true,

      dates: [],

      date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      dateMenu: false,
      dateData: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
    };
  },
  methods: {

    setDates() {
      var myCurrentDate = new Date();
      this.dates.push(myCurrentDate)
      var myPastDate = new Date(myCurrentDate);
      myPastDate.setDate(myPastDate.getDate() - 7);//myPastDate is now 7 days in the past
      this.dates.push(myPastDate)
      console.log("HERE... dates: "+this.dates)
    },

    changeDateData(e) {
      this.dateData = e;
      console.log("HERE... change dateData:"+this.dateData)
      this.$root.$emit("changeDateData", this.dateData);
    },

    selectAll() {
      let boxes = document.querySelectorAll("input");
      for (let box of boxes) {
        box.checked = true;
      }
    },
    userHistory() {
      this.Apps.userHistory();
    },
    offerHistory() {
      this.Apps.offerHistory();
    },

    retrieveRequests() {
      if (this.$store.state.auth.user.roles == "ROLE_ADMIN" 
          && this.$store.state.auth.user.username == "admin@localhost.com") {
        RequestDataService.getAll()
        .then((response) => {
            this.requests = response.data;
            console.log("HERE... load requests sucessfull: " + response.data);
            this.requestsInfo();
          })
          .catch((e) => {
            console.log("HERE... load requests error: " + e);
          });
      } else {
        RequestDataService.findByCountryCode(this.$store.state.auth.user.countryCode)
          .then((response) => {
            this.requests = response.data;
            console.log("HERE... load requests sucessfull: " + response.data);
            this.requestsInfo();
          })
          .catch((e) => {
            console.log("HERE... load requests error: " + e);
          });
      }
    },

    retrieveOffers() {
      if (this.$store.state.auth.user.username == "admin@localhost.com") {
        OfferDataService.getAll()
          .then((response) => {
            this.offers = response.data;
            console.log("HERE... load offers sucessfull: " + response.data);
            this.offersInfo();
          })
          .catch((e) => {
            console.log("HERE... load offers error: " + e);
          });
      } else {
        OfferDataService.findByCountryCode(this.$store.state.auth.user.countryCode)
          .then((response) => {
            this.offers = response.data;
            console.log("HERE... load offers sucessfull: " + response.data);
            this.offersInfo();
          })
          .catch((e) => {
            console.log("HERE... load offers error: " + e);
          });
      }
    },    

    selectNewRequests() {
      this.fiveLatestRecords = this.fiveLatestRequests
      console.log("CHECK select new requests...", this.fiveLatestRecords);
    },

    async selectNewOffers() {
      this.fiveLatestRecords = this.fiveLatestOffers
      console.log("CHECK select new offers...", this.fiveLatestRecords);
    },

    changeFlexMarket() {
      this.showingPrice = !this.showingPrice;
      this.showingVolume = !this.showingVolume;
    },

    changeWholeSaleMarket() {
      this.changeDateData(this.dateData);
      this.showingDayAhead = !this.showingDayAhead;
      this.showingIntraDay = !this.showingIntraDay;
    }

  },

  computed: {

    requestsInfo() {
      console.log("CHECK get requests...", this.requests);
      this.fiveLatestRequests = this.requests.slice(this.requests.length -5, this.requests.length).reverse();
      console.log("AND get five latest requests...", this.fiveLatestRequests);
      this.minRequestPrice = this.requests[0].price
      for (var i = 0; i < this.requests.length; i++) {
        this.totalRequest = this.totalRequest + this.requests[i].volume;
        if (this.minRequestPrice >=  this.requests[i].price) {
          this.minRequestPrice = this.requests[i].price
        }
        if (this.maxRequestPrice <=  this.requests[i].price) {
          this.maxRequestPrice = this.requests[i].price
        }
      }
    },

    offersInfo() {
      console.log("CHECK get offers...", this.offers);
      this.fiveLatestOffers = this.offers.slice(this.offers.length -5, this.offers.length).reverse();
      console.log("AND get five latest offers...", this.fiveLatestOffers);
      this.selectNewRequests();
      this.minOfferPrice = this.offers[0].price
      for (var i = 0; i < this.offers.length; i++) {
        this.totalOffer = this.totalOffer + this.offers[i].volume;
        if (this.minOfferPrice >=  this.offers[i].price) {
          this.minOfferPrice = this.offers[i].price
        }
        if (this.maxOfferPrice <=  this.offers[i].price) {
          this.maxOfferPrice = this.offers[i].price
        }
      }
    },

    dateRangeText () {
      return this.dates.join(' ~ ')
    },

  },

  updated() {
    // Fired every second, should always be true
    this.showingVolume;
    this.showingPrice;
    this.dateData;
    console.log("dateData: "+this.dateData)
  },

  mounted: function () {
    this.$nextTick(function () {
      this.retrieveRequests();
      this.retrieveOffers();
      this.setDates();
      this.changeDateData(this.dateData);
      // Code that will run only after the entire view has been rendered
    });
  },
};
</script>

<style lang="scss">
@import "../sass/main.scss";

.page-container-summary {
  min-height: 100vh;
  background: #f8fcff;
  padding-bottom: 50px;
  margin-top: -100px;
}

.nav-bar {
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.2);
  margin-top: -100px;
  margin-left: -10px;
}

.buy-wrapper {
  padding: 40px;
  background: #f8fcff;
}

.balance-flex2 {
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
}

.balance2 {
  display: flex;
  padding: 20px;
  position: relative;
  width: 47%;
  flex-direction: column;
  margin: 0 0 20px 0;
  border-radius: 10px;
  background: rgba(38, 56, 88, 1);
  background: -moz-linear-gradient(
    -45deg,
    rgba(38, 56, 88, 1) 0%,
    rgba(38, 56, 88, 1) 57%,
    rgba(71, 87, 115, 1) 75%,
    rgba(153, 164, 180, 1) 100%
  );
  background: -webkit-gradient(
    left top,
    right bottom,
    color-stop(0%, rgba(38, 56, 88, 1)),
    color-stop(57%, rgba(38, 56, 88, 1)),
    color-stop(75%, rgba(71, 87, 115, 1)),
    color-stop(100%, rgba(153, 164, 180, 1))
  );
  background: -webkit-linear-gradient(
    -45deg,
    rgba(38, 56, 88, 1) 0%,
    rgba(38, 56, 88, 1) 57%,
    rgba(71, 87, 115, 1) 75%,
    rgba(153, 164, 180, 1) 100%
  );
  background: -o-linear-gradient(
    -45deg,
    rgba(38, 56, 88, 1) 0%,
    rgba(38, 56, 88, 1) 57%,
    rgba(71, 87, 115, 1) 75%,
    rgba(153, 164, 180, 1) 100%
  );
  background: -ms-linear-gradient(
    -45deg,
    rgba(38, 56, 88, 1) 0%,
    rgba(38, 56, 88, 1) 57%,
    rgba(71, 87, 115, 1) 75%,
    rgba(153, 164, 180, 1) 100%
  );
  background: linear-gradient(
    135deg,
    rgba(38, 56, 88, 1) 0%,
    rgba(38, 56, 88, 1) 57%,
    rgba(71, 87, 115, 1) 75%,
    rgba(153, 164, 180, 1) 100%
  );
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#263858', endColorstr='#99a4b4', GradientType=1 );
}

.summary-icon {
  color: #fff !important;
  position: absolute !important;
  top: 20px !important;
  right: 20px !important;
}

.summary-header {
  color: #fff;
}

.dash-balance {
  margin: 20px 0 0 0;
  font-size: 34px;
  color: #fff;
  font-weight: 700;
}

.dash-total {
  margin-top: -10px;
  font-size: 16px;
  color: #fff;
}

.offer-span {
  font-size: 16px;
  font-weight: 400;
}

.conversion {
  font-size: 0.8em;
  color: #999;
}

.summary-upper {
  display: flex;
  justify-content: space-between;
}

.summary-left2,
.summary-right2 {
  width: 48%;
  display: flex;
  flex-direction: column;
}

.summary-right2 {
  background-color: #fff;
  flex: 1;
  margin-left: 50px;
}

.transfer-button {
  margin-bottom: 35px;
  margin-left: auto;
}

.transfer-button a {
    color: #FFFFFF;
    text-decoration: none;
}

.transfer-button span {
  color: #fff;
  text-transform: none;
}

.summary-middle2 {
  display: flex;
  margin: 30px 0;
}

.summary-graph {
  flex: 1;
  width: 100%;
  position: relative;
  background: rgba(0, 0, 0, 0);
  overflow-x: hidden;
}

.summary-middle-table2 {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-right: 0;
  margin-top: 40px;
}

.summary-middle-table table {
  margin: 0;
}

.buy-wrapper table {
  width: 100%;
  border-spacing: 0;
  border-collapse: collapse;
}

.table-wrapper2,
.dash-candle {
  background-color: #fff;
  padding: 20px;
}

.table-wrapper2 th {
  color: #979797;
  font-size: 12px;
  text-transform: uppercase;
  font-weight: 600px;
  padding: 15px;
  text-align: left;
}

.table-wrapper2 td {
  color: #000;
  font-size: 14px;
  font-weight: 600px;
  padding: 15px;
  text-align: left;
}

.transactions {
  width: 100%;
}

.table-headline2 {
  font-size: 22px;
  color: #000;
  margin-bottom: 20px;
}

.dashboard-left-top {
  display: flex;
  justify-content: space-between;
}

.dashboard-right-top {
  display: flex;
  justify-content: space-between;
  align-content: center;
  margin-left: 20px;
}

.dashboard-right-top2 {
  display: flex;
  justify-content: space-between;
  align-content: center;
}


// .dashboard-right-top .theme--light.v-btn--active:before, .theme--light.v-btn--active:hover:before {
//   opacity: 1 !important
// }

// .dashboard-right-top .theme--light.v-btn--active:before, .theme--light.v-btn--active span {
//   color: #fff !important;
// }

.dash-head .v-btn-toggle > .v-btn.v-btn--active {
  color: #fff !important;
  background-color: #59c26b !important;
  opacity: 1 !important;
}
.dash-head .v-btn-toggle {
  display: flex !important;
  justify-content: center;
  align-items: center;
  height: auto !important;
}

.dash-head .v-btn-toggle > .v-btn.v-btn {
  padding: 0 45px !important;
  border-width: 0 !important;
}

.dash-head
  .v-btn-toggle:not(.v-btn-toggle--dense)
  .v-btn.v-btn.v-size--default {
  height: 36px !important;
}

.dash-head .toggle-button > .v-btn__content {
  font-size: 14px;
  text-transform: none;
}
.dash-head .v-btn.v-btn--active > .v-btn__content .v-icon {
  color: #fff !important;
}

.dash-toggle {
  margin-left: 30px;
  margin-bottom: 20px;
}

.headline-wrapper {
  margin-top: 30px;
  padding: 20px;
}

.headline-subheader {
  color: #979797;
  font-size: 22px;
  margin-bottom: 20px
}

.headline-main {
  display: flex;
  justify-content: space-between;
}

.headline {
  display: flex;
  flex-direction: column;
  flex: 1;
  background-color: #fff
}

.headline-left {
  min-width: 45%
}

.headline-middle {
  min-width: 30%;
  margin: 0 50px;
}

.headline-right {
  min-width: 20%
}

.headline-img {
  width: 100%;
}

.headline-bold {
  font-weight: 700;
  font-size: 28px;
  padding: 20px;
}

.headline-text {
  font-size: 16px;
  padding: 0 20px 20px 20px;
  line-height: normal;
}

.headline-headline {
  margin-bottom: 0 !important
}
</style>
